"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademicYearOption = void 0;
/** One academic-year/lease-term/start-window association from Core. */
var AcademicYearOption = /** @class */ (function () {
    function AcademicYearOption() {
        this.id = 0;
        this.cid = 0;
        this.name = '';
        this.leaseTermId = 0;
        this.leaseStartWindowId = 0;
    }
    return AcademicYearOption;
}());
exports.AcademicYearOption = AcademicYearOption;
